import { useEffect, useState } from "react";
import CommunicationSet from "../../../../models/communications/CommunicationSet";
import Interval from "../../../../models/communications/Interval";
import Interaction from "../../../../models/interactions/Interaction";
import InteractionNode from "../../../../models/interactions/InteractionNode";
import InteractionNodeInterval from "../../../../models/interactions/InteractionNodeInterval";
import { useRowSelector } from "../../../../store/Hooks";
import InteractionDeleteButton from "../../../interactions/ui/InteractionDeleteButton";
import MatrixCell from "../MatrixCell";
import MatrixControls from "./MatrixControls";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

interface MatrixCommSetControls {
    commSetID: number | null;
    intervalID: number;
    intervalSetID: number;
    componentName: string;
    colSpan: number;
    commSetName: string;
    controlsBorderStyle: any;
    controlsBorderStyleNoSet: any;
    handleOpenEditCommunications: any;
    addNewIntervalToIntervalSet: any;
    associatedIntervals: Array<Interval>;
    associatedInteractionNodeIntervals: Array<InteractionNodeInterval>;
    associatedInteractionNodes: Array<InteractionNode>;
    associatedInteractions: Array<Interaction>;
    editMode: boolean;
    intervalSetName: string | null;
    parentHover: boolean;
}


const MatrixCommSetControls = (props: MatrixCommSetControls) => {
    const communicationSet = useRowSelector(CommunicationSet, props.commSetID || 0);
    const [editMode, setEditMode] = useState<boolean>(true);

    // useEffect(()=>{
    //     if(communicationSet?.shared){
    //         setEditMode(false)
    //     }
    // },[])
    return (
        <MatrixCell
            key={props.componentName}
            colSpan={props.colSpan}
            style={
                props.commSetName.length > 0
                    ? props.controlsBorderStyle
                    : props.controlsBorderStyleNoSet
            }
        >
            {" "}
            {props.commSetName.length > 0 && (
                <span
                    style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "11pt",
                        wordWrap: "break-word",
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: communicationSet?.shared ? "red" : "gray"
                    }}
                >
                    <div
                        style={{
                            display: "inline-block",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            padding: "0px",
                            fontSize: "11pt",
                            textDecoration: "underline",
                            cursor: "pointer",
                            wordWrap: "break-word",
                            marginLeft: "5px",
                            fontWeight: "bold",
                            backgroundColor: "#f2f4f7"
                        }}
                        onClick={() => {
                            if (editMode) {
                                props.handleOpenEditCommunications(props.commSetID, props.intervalID);
                            }
                        }}
                    >
                        <Tooltip title={"Edit shared communication set"}>
                            <span>
                                {communicationSet?.shared && <span><LockIcon style={{ color: "red"}} /></span>}
                                {props.commSetName}
                            </span>
                        </Tooltip>
                    </div>
                    {/* deleting a comm set here will require updating all of the intervals too */}
                    <span style={{ marginTop: "-25px" }}>
                        <MatrixControls
                            intervalSetID={props.intervalSetID}
                            parentHover={false}
                            addNewIntervalToIntervalSet={props.addNewIntervalToIntervalSet}
                            communicationSetID={props.commSetID}
                            associatedIntervals={[]}
                            associatedInteractionNodeIntervals={[]}
                            associatedInteractionNodes={[]}
                            associatedInteractions={[]}
                            editMode={props.editMode}
                            intervalSetName={null} />
                        <InteractionDeleteButton disabled={!editMode || !props.editMode} communicationSetID={props.commSetID} handler={async () => { await communicationSet?.delete() }} /></span>
                </span>
            )}
        </MatrixCell>
    )
}

export default MatrixCommSetControls